import React from "react";
import PractitionerAvatar from "./PractitionerAvatar";

export default ({ selected, practitioner, onClick }) => {
  return (
    <div
      key={practitioner.practitionerId}
      onClick={() => onClick(practitioner.practitionerId)}
      className={`drawer-card ${selected ? "selected" : ""}`}
    >
      <div className="practitioner-card">
        <div className="media">
          <PractitionerAvatar
            useInitial={practitioner.imageId === ""}
            src={practitioner.imageSrc}
            initial={`${practitioner.firstName.charAt(
              0
            )}${practitioner.lastName.charAt(0)}`.toUpperCase()}
          />
        </div>
        <div className="information-panel">
          <span className="info-title">{`${practitioner.firstName} ${
            practitioner.lastName
          }`}</span>
          <span className="info-desc">{practitioner.description}</span>
        </div>
      </div>
      {selected ? (
        <i className={`material-icons ${selected ? "selected-icon" : ""}`}>
          done
        </i>
      ) : null}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/DrawerContent/PractitionerListItem.js